import {Pagination} from "pansx-utils/src/index";


export class QueryList<T>{
    public size = 5;//展示条数
    public page = 1//当前页码
    public entity?: T
    public totalElements?: number;
    public totalPages?: number
    public content: T[]=[]
    public adminId?: string

    public getPagination(): Pagination {
        const pagination = new Pagination();
        pagination.page =this.page;
        pagination.rowsPerPage = this.size;
        pagination.rowsNumber = this.totalElements;
        return pagination;
    }

}